export function getMetrics(size, spacing) {
  const [cols, rows] = size.split('x');
  const res = {
    cols,
    rows,
    cell: {
      width: 100 / cols,
      height: 100 / rows,
    },
  };
  res.cell.minSize = Math.min(res.cell.width, res.cell.height);
  res.cell.maxSize = Math.max(res.cell.width, res.cell.height);

  if (spacing !== undefined) {
    res.cell.innerWidth = (res.cell.width * (100 - spacing)) / 100;
    res.cell.innerHeight = (res.cell.height * (100 - spacing)) / 100;
    res.cell.minInnerSize = Math.min(res.cell.innerWidth, res.cell.innerHeight);
    res.cell.maxInnerSize = Math.max(res.cell.innerWidth, res.cell.innerHeight);
  }

  return res;
}

export function computeCore(core, arg, vars, optionMeta, instance) {
  const method = _.get(core, arg.path);
  if (_.isFunction(method)) {
    const res = method({ ...arg, ...vars.layout }, optionMeta, instance);
    return res;
  }

  console.log('no compute method', arg.path, core);
}

export function createLink(arg, vars, core) {
  const staticValue = arg.path
    ? computeCore(core, arg, vars)
    : _.get(vars, arg);
  const link = {
    binding: {
      type: 'variableLink',
      variable: {
        path: (arg.path && 'layout.compute') || arg,
      },
    },
    staticValue,
  };
  if (arg.path) {
    link.binding.variable.arg = arg;
  }

  return link;
}
